export default {
  save: 'Save',
  saving: 'Saving…',
  saveChanges: 'Save changes',
  cancel: 'Cancel',
  close: 'Close',
  delete: 'Delete',
  deleting: 'Deleting…',
  remove: 'Remove',
  edit: 'Edit',
  add: 'Add',
  create: 'Create',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  done: 'Done',
  confirm: 'Confirm',
  continue: 'Continue',
  retry: 'Try again',
  search: 'Search',
  filter: 'Filter',
  clear: 'Clear',
  all: 'All',
  none: 'None',
  yes: 'Yes',
  no: 'No',
  or: 'or',
  loading: 'Loading…',
  optional: 'Optional',
  required: 'Required',
  name: 'Name',
  email: 'Email',
  phone: 'Phone',
  status: 'Status',
  actions: 'Actions',
  date: 'Date',
  start: 'Start',
  end: 'End',
  notes: 'Notes',
  today: 'Today',
  yesterday: 'Yesterday',
  somethingWentWrong: 'Something went wrong',
  language: 'Language',
  mockLocation: 'Mock location',
  mockLocationHint: 'The phone reported this position as coming from a location-spoofing app, so where this person was is not verified.',
}
